if (!customElements.get('advanced-optin')) {
  customElements.define(
    'advanced-optin',
    class AdvancedOptin extends HTMLElement {
      constructor () {
        super();
        this.tag = this.querySelector('input[name="contact[tags]"]');
      }

      handleChange (event) {
        this.tag.value = `Tips for: ${event.target.value}`;
      }

      connectedCallback () {
        if (this.tag) {
          this.querySelectorAll('input[name="preference"]').forEach((item) => {
            item.addEventListener('change', this.handleChange.bind(this));
            if (item.hasAttribute('data-checked')) {
              item.removeAttribute('data-checked');
              item.checked = true;
              item.dispatchEvent(new Event('change'));
            }
          });
        }
      }

      disconnectCallback () {
        if (this.tag) {
          this.querySelectorAll('input[name="preference"]').forEach((item) => {
            item.removeEventListener('change', this.handleChange.bind(this));
          });
        }
      }
    },
  );
}